module.exports = __webpack_public_path__ + "images/home6.webp";